<template>
  <div class="start-dispute__popup">
    <div class="start-dispute__popup-title">{{i18n.cont_start_a_dispute()}}</div>
    <form @submit.prevent="submit"
          class="start-dispute__form">
      <div class="start-dispute__row">
        <div class="start-dispute__field">
          <h3 class="start-dispute__field-title">{{i18n.lbl_document()}}</h3>
          <file-field fileType="image"
                      v-validate="'required'"
                      name="dispute-file"
                      :type="documentTypes.dispute"
                      v-model="documents.dispute"/>
        </div>
        <div class="start-dispute__field">
          <h3 class="start-dispute__field-title">{{i18n.lbl_note()}}</h3>
          <textarea-field v-model="form.note"
                          name="dispute-note"
                          v-validate="'required'" />
        </div>
      </div>
      <div class="start-dispute__submit-wrapper">
        <md-button type="submit" class="md-primary"
          :disabled="isPending"
        >{{ i18n.lbl_submit() }}</md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { i18n } from '@js/i18n'
import { documentTypes } from '@const'

import FormMixin from '@com/mixins/form.mixin'
import FileField from '@com/fields/FileField'
import { ErrorHandler } from '@js/errors/error_handler'
import { EventDispatcher } from '@js/events/event_dispatcher'
import { contractsService } from '@api/contracts.service'
import { fileService } from '@api/file.service'

export default {
  components: { FileField },
  props: ['contractId'],
  mixins: [FormMixin],
  data: _ => ({
    i18n,
    documentTypes,
    isLoading: false,
    form: {
      note: ''
    },
    documents: {
      dispute: null
    }
  }),

  methods: {
    async submit () {
      if (!await this.isValid()) return
      this.disable()
      try {
        const disputeFile = this.documents.dispute
        if (disputeFile && !disputeFile.isUploaded) {
          const disputeFileKey = await fileService.uploadFile(disputeFile.getDetailsForUpload())
          disputeFile.setKey(disputeFileKey)
        }
        const disputeReason = {
          dispute_file: disputeFile.getDetailsForSave(),
          note: this.form.note
        }
        await contractsService.startDispute({
          contractID: this.contractId,
          disputeReason
        })
        this.$emit('close-request')
        EventDispatcher.dispatchShowSuccessEvent(i18n.cont_dispute_submitted())
      } catch (e) {
        console.error(e)
        ErrorHandler.processUnexpected(e)
      }
      this.enable()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .start-dispute__popup-title {
    line-height: 1.625rem;
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }

  .start-dispute__form {
    display: flex;
    flex-direction: column;
  }

  .start-dispute__row {
    display: flex;
    justify-content: space-between;
  }

  .start-dispute__field {
    width: 49%;
  }

  .start-dispute__submit-wrapper {
    text-align: right;
    margin-right: -1.5rem;
  }

  .start-dispute__field-title {
    margin-bottom: 1rem;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/modals/Contracts.StartDispute.vue